/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/self-closing-comp */
import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import APP_ROUTES from '../../constants/app-routes';
import { priceFormat } from '../../helper';

import imgKWallet from '../../images/kwallet-logo.svg';

const Banner = ({ accountBalance, availableBalance, activeWallet, kWalletId, transferFunds, intl }) => {
    const [isWalletIdRevealed, setIsWalletIdRevealed] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const copyIcon = isCopied ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-clipboard-check-fill" viewBox="0 0 16 16">
            <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z" />
            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708Z" />
        </svg>
    ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-clipboard-fill" viewBox="0 0 16 16">
            <path
                fillRule="evenodd"
                d="M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z"
            />
        </svg>
    );
    const onKWalletIdCopied = () => {
        navigator.clipboard
            .writeText(kWalletId)
            .then(() => {
                setIsCopied(true);
            })
            .catch((err) => console.log(err));
    };

    return (
        <section className="section-banner">
            <div className="banner-message">
                <img src={imgKWallet} alt="K-Wallett" />
                <h4 className="banner-header">
                    <FormattedMessage
                        id="manage-k-wallet-banner-message"
                        defaultMessage="Nuestro exclusivo Programa de Tarjeta Recargable hace que las transacciones financieras sean fáciles y seguras"
                    />
                </h4>
                <ul className="banner-messages">
                    <li>
                        <FormattedMessage id="manage-k-wallet-banner-direct-deposit" defaultMessage="Depósito directo (ACH debit)" />
                    </li>
                    <li>
                        <FormattedMessage id="manage-k-wallet-banner-load-card" defaultMessage="Carga de tarjeta" />
                    </li>
                    <li>
                        <FormattedMessage id="manage-k-wallet-banner-peer-to-peer-transfer" defaultMessage="Transferencia de crédito de usuario a usuario" />
                    </li>
                    <li>
                        <FormattedMessage id="manage-k-wallet-banner-check-your-balance" defaultMessage="Consulta de saldo" />
                    </li>
                    <li>
                        <FormattedMessage id="manage-k-wallet-banner-pay-the-bill" defaultMessage="Pago de la factura" />
                    </li>
                </ul>
            </div>
            {activeWallet && (
                <div className="banner-links">
                    <div className="balance-summary">
                        <div className="balance-summary__col balance-summary__col-left">
                            <div className="balance-summary__col__label">
                                <FormattedMessage id="manage-k-wallet-banner-account-balance" defaultMessage="Saldo actual:" />
                            </div>
                            <div className="balance-summary__col__label" style={{ fontSize: '15px' }}>
                                <FormattedMessage id="manage-k-wallet-banner-available-balance" defaultMessage="Saldo disponible:" />
                            </div>
                            <div className="balance-summary__col__label" style={{ marginTop: '16px' }}>
                                <FormattedMessage id="manage-k-wallet-banner-your-k-wallet-id" defaultMessage="K-Wallet ID" />
                            </div>
                        </div>
                        <div className="balance-summary__col balance-summary__col-right">
                            <div className="balance-summary__col__value">
                                <span>{accountBalance !== undefined ? priceFormat.format(accountBalance) : '...'}</span>
                            </div>
                            <div className="balance-summary__col__value" style={{ fontSize: '15px' }}>
                                <span>{availableBalance !== undefined ? priceFormat.format(availableBalance) : '...'}</span>
                            </div>
                            <div className="balance-summary__col__wallet-id">
                                {!isWalletIdRevealed && (
                                    <span style={{ flex: '1 1 auto' }} onClick={() => setIsWalletIdRevealed(!isWalletIdRevealed)}>
                                        <OverlayTrigger placement="top" shouldUpdatePosition overlay={<Tooltip id={Math.random()}>{intl.formatMessage({ id: 'manage-k-wallet-banner-click-to-reveal', defaultMessage: 'Click to reveal' })}</Tooltip>}>
                                            <input readOnly type="password" className="form-control" value={kWalletId || ''} />
                                        </OverlayTrigger>
                                    </span>
                                )}
                                {isWalletIdRevealed && <input style={{ flex: '1 1 auto' }} readOnly type="text" className="form-control" value={kWalletId || ''} />}
                                <span className="copy-icon" onClick={() => onKWalletIdCopied()}>
                                    <OverlayTrigger
                                        placement="top"
                                        shouldUpdatePosition
                                        overlay={
                                            // eslint-disable-next-line react/jsx-one-expression-per-line
                                            <Tooltip id={Math.random()}>{isCopied ? intl.formatMessage({ id: 'manage-k-wallet-banner-copied', defaultMessage: 'Copiado!' }) : intl.formatMessage({ id: 'manage-k-wallet-banner-copy-to-clipboard', defaultMessage: 'Copiar' })}</Tooltip>
                                        }
                                    >
                                        <span>{copyIcon}</span>
                                    </OverlayTrigger>
                                </span>
                            </div>
                        </div>
                    </div>
                    <Link className="banner-main-cta" to={APP_ROUTES.addFundsKWallet}>
                        <FormattedMessage id="manage-k-wallet-banner-add-funds" defaultMessage="Agregar fondos a K-Wallet" />
                    </Link>
                    <div className="banner-links-subtitle">
                        <FormattedMessage id="manage-k-wallet-banner-to-use-k-wallet" defaultMessage="Para aprovechar K-Wallet, siga estos pasos:" />
                    </div>
                    <ul className="banner-links-k-wallet">
                        <li>
                            <a href="#" onClick={transferFunds}>
                                <FormattedMessage id="manage-k-wallet-banner-transfer-money-link" defaultMessage="Enviar dinero a un receptor" />
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </section>
    );
};

export default injectIntl(Banner);



/** WEBPACK FOOTER **
 ** ./src/components/k-wallet/banner.jsx
 **/